import BtnDownloadComponent from './BtnDownload'
import BtnCloseComponent from './BtnClose'
import BtnShareComponent from './BtnShare'
import PopupFrameComponent from './PopupFrame'
import BtnPlayVideoComponent from './BtnPlayVideo'
import IconTextComponent from './IconText'

export const BtnDownload = BtnDownloadComponent
export const BtnClose = BtnCloseComponent
export const BtnShare = BtnShareComponent
export const PopupFrame = PopupFrameComponent
export const BtnPlayVideo = BtnPlayVideoComponent
export const IconText = IconTextComponent
